<template>
    <div class="panel_container" :class="{ pp_group: props.groupName === 'PP' }"
        :style="{ color: customStyles.active_font_color }">
        <img src="@/assets/themeThree/headerTextBg.png" alt="" width="80%">
        <van-row class="titleHead" justify="space-between" style="margin-bottom: 10px;">
            <van-col span="15" class="group_col">
                <img :src="props.groupImage" alt="">
                <div class="groupName">{{ $t(groupName) }}</div>
                <div class="slashLine"></div>
                <div class="gameCount">
                    <div class="countText">{{ gameCount }}</div>
                    <div>{{ $t('message.all') }}</div>
                </div>
            </van-col>
            <van-col span="8" class="group_col_right">
                <div class="arrowBtn" @click="prevPage"><van-icon name="arrow-left" /></div>
                <div class="arrowBtn" @click="nextPage"><van-icon name="arrow" /></div>
            </van-col>
        </van-row>
        <div class="game-slider-container">
            <!-- <van-grid :column-num="gameGrid.columnCount" :gutter="2" :border="false">
                <van-grid-item v-for="item in paginatedGameList" :key="item.id">
                    <GameCard :gameImage="item.customIcon" :gameTypeId="item.id" :gameIsFavorite="item.isFavorite"
                        @clickGameCard="GoToPlayGame(item.gameId, item.gameMakerId)" />
                </van-grid-item>
            </van-grid> -->
            <div v-if="!isShowAllGame" class="game-slider-container">
                <div class="game-track" :style="{ transform: 'translate3d(-' + (currentPage * 100) + '%, 0, 0)' }">
                    <div v-for="(page, pageIdx) in pages" :key="pageIdx" class="page-block">
                        <van-grid :column-num="gameGrid.columnCount" :border="false">
                            <van-grid-item v-for="item in page" :key="item.id" class="grid-item">
                                <GameCard :gameImage="item.customIcon" :gameTypeId="item.id"
                                    :gameIsFavorite="item.isFavorite"
                                    @clickGameCard="GoToPlayGame(item.activeGameId, item.gameMakerId, item.isFavorite, item.id)" />
                            </van-grid-item>
                        </van-grid>
                    </div>
                </div>
            </div>
            <div v-else class="game-slider-container">
                <div class="page-block" :key="currentPage"> <van-grid :column-num="gameGrid.columnCount"
                        :border="false"> <van-grid-item v-for="item in props.gameList" :key="item.id" class="grid-item">
                            <GameCard :gameImage="item.customIcon" :gameTypeId="item.id"
                                :gameIsFavorite="item.isFavorite"
                                @clickGameCard="GoToPlayGame(item.activeGameId, item.gameMakerId, item.isFavorite, item.id)" />
                        </van-grid-item> </van-grid> </div>
            </div>

            <div class="bottomText">{{ $t('game.moreGameText', {
                displayCount: (isShowAllGame ? gameCount : displayCount),
                gameCount: gameCount }) }}
            </div>
            <div class="showAllText">
                <div v-if="!isShowAllGame && gameCount > 12" @click="showGames">{{ $t('game.showAll') }}<van-icon
                        name="arrow-down" class="showIcon" /></div>
                <div v-if="isShowAllGame && gameCount > 12" @click="showGames">{{ $t('game.collect') }}<van-icon
                        name="arrow-up" class="showIcon" /></div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, inject, onMounted, ref } from 'vue'
import { PropType } from 'vue'
import GameCard from '../../game/components/gameCard.vue';
import { playClickSound } from '@/utils/media';
import { useRouter } from 'vue-router';
import { GameGroupData, GameList, goToPlayGame } from '@/view/home/supportScript';
const slideDirection = ref<'left' | 'right'>('right')
const gameGrid = ref({
    rowCount: 0,
    columnCount: 0
})
const customStyles = ref({
    active_font_color: '',
    border_color: ""
})
const props = defineProps({
    gameList: {
        type: Array as PropType<GameList[]>,
        required: true
    },
    groupImage: {
        type: String,
        default: ''
    },
    groupName: {
        type: String,
        default: ''
    },
    itemData: {
        type: Object as PropType<GameGroupData>,
        required: true
    },
    itemIndex: {
        type: Number,
    }

})
const router = useRouter()
const gameCount = computed(() => props.gameList.length);
const displayCount = computed(() => props.gameList.length < 12 ? props.gameList.length : 12);
const isShowAllGame = ref(false)
const openRegisterLoginPopup = inject<(type: number) => void>('openRegisterLoginPopup')
const emits = defineEmits(['showGames'])
const currentPage = ref(0)
const pageSize = computed(() => {
    const size = gameGrid.value.rowCount * gameGrid.value.columnCount
    return size > 0 ? size : 12
})

const totalPages = computed(() => {
    return Math.ceil(props.gameList.length / pageSize.value)
})

const paginatedGameList = computed(() => {
    const start = currentPage.value * pageSize.value
    return props.gameList.slice(start, start + pageSize.value)
})

const pages = computed(() => {
    const list = []
    const size = pageSize.value
    for (let i = 0; i < totalPages.value; i++) {
        const start = i * size
        list.push(props.gameList.slice(start, start + size))
    }
    return list
})


const nextPage = () => {
    if (process.env.VUE_APP_PREVIEW_MODE == 'true') return
    if (currentPage.value < totalPages.value - 1) {
        playClickSound()
        slideDirection.value = 'right'
        currentPage.value++
    }
}

const prevPage = () => {
    if (process.env.VUE_APP_PREVIEW_MODE == 'true') return
    if (currentPage.value > 0) {
        playClickSound()
        slideDirection.value = 'left'
        currentPage.value--
    }
}
const GoToPlayGame = (id: any, makerId: any, favorite: number, favId: any) => {
    goToPlayGame(router, openRegisterLoginPopup, id, makerId, favorite, favId)
}
const showGames = () => {
    isShowAllGame.value = !isShowAllGame.value
}
onMounted(() => {
    gameGrid.value.rowCount = props.itemData.gamesGrid.rowCount
    gameGrid.value.columnCount = props.itemData.gamesGrid.columnCount
    customStyles.value.active_font_color = props.itemData.styles.active_font_color
    customStyles.value.border_color = props.itemData.styles.border_color
})
</script>
<style scoped>
.panel_container {
    padding: 0px 0px 25px;
    font-weight: 600;
    background: #1a223a;
    margin-top: 15px;
    border-radius: 18px;
    position: relative;
}

.bottomText {
    padding: 10px 0;
    text-align: center;
    font-weight: 500;
}

.showAllText {
    color: #106fcd;
    font-weight: bold;
    text-align: center;
}

.showIcon {
    background: #106fcd;
    border-radius: 30px;
    padding: 3px;
    color: rgba(0, 0, 0, 0.399);
    font-size: 10px;
    margin: 5px;
}

.titleHead {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
}

.group_col {
    display: flex;
    padding: 10px;
    align-items: center;
}

.groupName {
    padding-left: 10px;
    font-size: 20px;
    font-weight: 800;
}

.slashLine {
    background-color: #1680DC;
    width: 35px;
    height: 1.5px;
    font-size: 35px;
    rotate: 120deg;
    margin: 5px;
}

.gameCount {
    display: flex;
    flex-direction: column;
    font-size: 15px;
    color: #727b8f;
    text-align: right;
    font-weight: 500;
}

.countText {
    color: #fff;
    font-weight: 700;
}

.left-borer {
    border-right: 4px solid #dd8b33;
    margin: 3px 0px;
}

.group_name {
    font-size: 15.4px;
    padding: 0 5px;
    font-weight: 700;
}

.group_col_right {
    display: flex;
    align-items: center;
    justify-content: right;
    padding: 15px;
}

.group_col img {
    width: 25px;
    filter: invert(38%) sepia(497%) saturate(131%) hue-rotate(161deg) brightness(84%) contrast(243%);
    opacity: 0.7;
}

.more_button {
    display: flex;
    align-items: center;
    background: #ff69b4;
    font-weight: 400;
    padding: 5px 10px;
    border-radius: 4px;
    font-size: 14px;
    color: #fff;
}

.game_list {
    display: flex;
    justify-content: left;
    padding: 5px;
}

.game_count {
    margin: 0 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 13px;
    border-radius: 5px;
    padding: 3px 8px;
}

.more_button img {
    width: 17px;
    padding-left: 5px;
}

.game-slider-container {
    position: relative;
    padding: 5px;
}

.game-slider-container>>>.van-grid-item__content {
    background-color: transparent;
    display: flex;
    justify-content: left;
    padding: 5px;
}

.game-slider-container>>>.van-grid-item__content:after {
    border: none;
}

.arrow {
    position: absolute;
    top: 40%;
    font-size: 24px;
    color: white;
    cursor: pointer;
    z-index: 10;
    border-radius: 50%;
    user-select: none;
}

.arrow.left {
    left: 0;
}

.arrow.left img {
    width: 15px;
    margin-left: -5px;
}

.arrow.right {
    right: 0;
}

.arrow.right img {
    width: 15px;
    transform: rotate(180deg);
    margin-right: -15px;
}

.bottom_text {
    color: #d1d1d1;
    font-size: 14px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 10px;
}

.bottom_text img {
    width: 10px;
    background: rgba(0, 0, 0, 0.65);
    padding: 3px;
    border-radius: 30px;
    margin-left: 5px;
}

.arrowBtn {
    display: flex;
    align-items: center;
    background: #354165;
    padding: 8px;
    margin-right: 5px;
    border-radius: 30px;
    font-size: 16px;
    color: #727b8f;
}

.game-slider-container {
    position: relative;
    overflow: hidden;
}

.game-track {
    display: flex;
    transition: transform 360ms ease;
    width: 100%;
    will-change: transform;
}

.page-block {
    width: 100%;
    flex-shrink: 0;
    box-sizing: border-box;
    padding: 0;
    backface-visibility: hidden;
}

.grid-item {
    box-sizing: border-box;
}

.slide-right-enter-from {
    transform: translateX(100%);
    opacity: 0;
}

.slide-right-enter-active {
    transition: transform 360ms ease, opacity 360ms ease;
}

.slide-right-enter-to {
    transform: translateX(0);
    opacity: 1;
}

.slide-right-leave-from {
    transform: translateX(0);
    opacity: 1;
}

.slide-right-leave-active {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    transition: transform 360ms ease, opacity 360ms ease;
}

.slide-right-leave-to {
    transform: translateX(-100%);
    opacity: 0;
}

.slide-left-enter-from {
    transform: translateX(-100%);
    opacity: 0;
}

.slide-left-enter-active {
    transition: transform 360ms ease, opacity 360ms ease;
}

.slide-left-enter-to {
    transform: translateX(0);
    opacity: 1;
}

.slide-left-leave-from {
    transform: translateX(0);
    opacity: 1;
}

.slide-left-leave-active {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    transition: transform 360ms ease, opacity 360ms ease;
}

.slide-left-leave-to {
    transform: translateX(100%);
    opacity: 0;
}

@media (max-width:450px) {
    .groupName {
        font-size: 15px;
    }

    .group_col {
        padding: 5px 10px;
    }

    .gameCount {
        font-size: 12px;
    }

    .group_col_right {
        padding: 10px;
    }

    .slashLine {
        width: 30px;
    }
}
</style>